const EARLIEST_TRACKING_YEAR = 2017;

export function getTrackingYears() {
  const currentYear = new Date().getFullYear();
  return Array.from(
    { length: currentYear - EARLIEST_TRACKING_YEAR + 2 },
    (_, i) => String(currentYear + 1 - i)
  );
}
